import type { CustomConversionDescriptor, KeyEventDescriptor } from '../models/conversion.types'

export const GA4_KEY_EVENTS: KeyEventDescriptor = {
  platform: 'ga4',
  channel: 'ga4',
  idKey: 'property_id',
  eventsKey: 'custom_key_events',
  primaryKey: 'ga4_primary_events',
  logo: 'ga4',
}

export const MMP_KEY_EVENTS: Readonly<Record<'adjust' | 'appsflyer', KeyEventDescriptor>> = {
  adjust: {
    platform: 'adjust',
    channel: 'adjust',
    eventsKey: 'mmp_key_events',
    primaryKey: 'mmp_primary_event',
    logo: 'adjust',
  },
  appsflyer: {
    platform: 'appsflyer',
    channel: 'appsflyer',
    eventsKey: 'mmp_key_events',
    primaryKey: 'mmp_primary_event',
    logo: 'appsflyer',
  },
}

export const CUSTOM_CONVERSIONS: Readonly<Record<'meta' | 'google', CustomConversionDescriptor>> = {
  meta: {
    platform: 'meta',
    catalogKey: 'meta_customconversions',
    mappingKey: 'metaads_custom_conversions_mapping',
    legacyMappingKey: 'meta_custom_conversions_mapping',
  },
  google: {
    platform: 'google',
    catalogKey: 'google_customconversions',
    mappingKey: 'google_custom_conversions_mapping',
  },
}
